import { Action, combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { configureStore } from "@reduxjs/toolkit";

import availabilitySettingReducer from "./doctor/availabilitySettings";
import appointmentReducer from "./doctor/appointment";
import scheduleReducer from "./doctor/schedule";
import doctorProfileReducer from "./doctor/profile";
import topNavigationReducer from "./doctor/topNavigation";
import prescriptionReducer from "./doctor/prescription";
import medicalRecordsReducer from "./doctor/medicalRecord";
import ipDashboardReducer from "./doctor/ipDashboard";
import checkMobilePatientExistOrNotReducer from "./doctor/checkMobilePatientExistOrNot";
import dashboardReducer from "./doctor/dashboard";

import memberReducer from "./patient/member";
import findDoctorReducer from "./patient/findDoctor";
import homeModuleReducer from "./patient/home";
import healthAssessmentReducer from "./patient/healthAssessment";
import medicineReducer from "./patient/medicine";
import healthHubReducer from "./patient/healthHub";
import paymentReducer from "./patient/payment";

import configReducer from "./config";
import onboardingReducer from "./onboarding/onboarding";

import videoAppointmentReducer from "./videoAppointment";
import permissionReducer from "./permission";
import testsReducer from "./patient/tests";

import pharmacyClinicDiagnosticReducer from "./pharmacyClinicDiagnostic";

import report from "../slices/reports/report";

import chatSliceReducer from "./chat";

import universalSearchFilterReducer from "./doctor/universalSearchFilter";

import { IResetAppState } from "@/models";

const appReducer = combineReducers({
  availability: availabilitySettingReducer,
  member: memberReducer,
  appointment: appointmentReducer,
  videoAppointment: videoAppointmentReducer,
  rolePermission: permissionReducer,
  schedule: scheduleReducer,
  config: configReducer,
  findDoctor: findDoctorReducer,
  home: homeModuleReducer,
  healthAssessment: healthAssessmentReducer,
  medicine: medicineReducer,
  healthHub: healthHubReducer,
  doctorProfile: doctorProfileReducer,
  topNavigation: topNavigationReducer,
  prescription: prescriptionReducer,
  medicalRecords: medicalRecordsReducer,
  ipDashboard: ipDashboardReducer,
  patientExistOrNot: checkMobilePatientExistOrNotReducer,
  onboarding: onboardingReducer,
  tests: testsReducer,
  pharmacyClinicDiagnostic: pharmacyClinicDiagnosticReducer,
  chat: chatSliceReducer,
  payment: paymentReducer,
  dashboard: dashboardReducer,
  ...report,
  universalSearchFilter: universalSearchFilterReducer,
});

export type RootState = ReturnType<typeof appReducer>;

const rootReducer = (state: RootState | undefined, action: Action) => {
  if (action.type === IResetAppState.RESET_ALL) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["universalSearchFilter"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  devTools: import.meta.env.DEV,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "FLUSH",
          "REHYDRATE",
          "PAUSE",
          "PERSIST",
          "PURGE",
          "REGISTER",
          "persist/PERSIST"
        ],
      },
    }),
});

const persistor = persistStore(store);

export { rootReducer, persistor, store };
